import { useEffect, useState, useRef } from 'react';

export function useThrottledValue<T>(value: T, limit: number): T {
	const [throttledValue, setThrottledValue] = useState(value);
	const lastRan = useRef<number>(Date.now());

	useEffect(() => {
		const handler = () => {
			const now = Date.now();

			if (now - lastRan.current >= limit) {
				setThrottledValue(value);
				lastRan.current = now;
			}
		};

		// Execute immediately if enough time has passed
		handler();

		const timeoutId = setTimeout(() => {
			// Ensure we always eventually get the latest value
			if (throttledValue !== value) {
				setThrottledValue(value);
				lastRan.current = Date.now();
			}
		}, limit);

		return () => {
			clearTimeout(timeoutId);
		};
	}, [value, limit, throttledValue]);

	return throttledValue;
}
